import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { ReviewKind } from './types';
import { KIND_META } from './constants';

interface Props {
  kind: ReviewKind;
}

export default function EmptyBody({ kind }: Props): React.ReactElement {
  const navigate = useNavigate();
  const meta = KIND_META[kind];
  return (
    <div className="bg-white rounded-lg border border-lineSoft text-center px-6 py-12">
      <div className="w-14 h-14 rounded-full bg-gradient-to-br from-vela to-vela-deep text-white font-extrabold text-[26px] inline-flex items-center justify-center mx-auto mb-3 shadow-velaDot">
        V
      </div>
      <h3 className="text-[17px] font-extrabold text-ink m-0 mb-1.5">
        {meta.emptyTitle}
      </h3>
      <p className="text-small text-helper max-w-[400px] mx-auto mb-5 leading-[1.5]">
        {meta.emptyDesc}
      </p>
      <div className="inline-flex gap-2.5">
        <button
          type="button"
          onClick={() => navigate('/accounting/chart-of-accounts')}
          className="h-[38px] px-4 border border-line bg-white text-small font-semibold text-ink2 rounded-lg cursor-pointer"
        >
          Back to Chart of accounts
        </button>
        <button
          type="button"
          onClick={() => navigate('/accounting/chart-of-accounts/cleanup-history')}
          className="h-[38px] px-5 bg-ink text-white text-small font-bold rounded-lg cursor-pointer border-none"
        >
          See Cleanup history
        </button>
      </div>
    </div>
  );
}